export class AdUpdateRequest {
    newAdImageId: string;
    adId: number;
}